// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"style_mainDiv__PnTv3","noDataFoundImg":"style_noDataFoundImg__2uip5","notFoundTxt":"style_notFoundTxt__ERZKi"};